import React from "react";

const WorkPage = () => {
  return (
    <div>
      <h1>Some of my recent projects</h1>
      <ul>
        <li>Project A - Description of project A - Link to project A</li>
        <li>Project B - Description of project B - Link to project B</li>
        <li>Project C - Description of project C - Link to project C</li>
      </ul>
    </div>
  );
};

export default WorkPage;
